import { Box, Stack } from "@mui/system";
import { motion } from "framer-motion";
import { CLASSES, ClassNameType } from "./ClassSelector/ClassData";
import Student from "./Student";

const gap = 2;

export const MotionGrid = (props: { selectedClass: ClassNameType[] }) => {
  const { selectedClass } = props;

  const students = selectedClass.flatMap((cls) =>
    CLASSES[cls].students.map((student) => ({
      id: student,
      class: cls,
    }))
  );

  const numberOfStudentsInClass = students.length;
  const numberOfCols = 4;

  return (
    <Box sx={{ perspective: "300px" }}>
      <Stack
        direction="row"
        gap={gap}
        sx={{
          transform: "rotateX(5deg)",
          transformOrigin: "center center",
        }}
      >
        {[...Array(numberOfCols)].map((_, index) => {
          const start = index * (numberOfStudentsInClass / numberOfCols);
          const end = start + numberOfStudentsInClass / numberOfCols;

          return (
            <InfiniteColumn
              key={index}
              students={students.slice(start, end)}
              direction={index % 2 === 0 ? "up" : "down"}
              delay={index * 0.5}
            />
          );
        })}
      </Stack>
    </Box>
  );
};

function InfiniteColumn({
  students,
  direction,
  delay = 0,
}: {
  students: { id: string; class: ClassNameType }[];
  direction: "up" | "down";
  delay?: number;
}) {
  return (
    <Box
      sx={{
        width: "25vw",
        height: "100vh",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <Stack
        gap={gap}
        component={motion.div}
        style={{
          position: "absolute",
          top: 0,
          width: "100%",
        }}
        animate={{
          y: direction === "up" ? ["0%", "-50%"] : ["-50%", "0%"],
        }}
        transition={{
          duration: 60,
          ease: "linear",
          repeat: Infinity,
          delay: delay,
        }}
      >
        {[...students, ...students].map(
          ({ id, class: studentClass }, index) => (
            <Student key={index} id={id} _class={studentClass} />
          )
        )}
      </Stack>
    </Box>
  );
}
